import React, { useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'

import { operationsCountriesOptions } from '../../SroiReportPayloadEdit/SroiReportPayloadEditForm/fields'
import { ETHNICITY_PERCENTAGE, STAKEHOLDERS_LIST } from '../../stakeholdersFields'
import { COUNTRY_ID } from '../../fields'

const CountryOfOperationField = ({ formik }) => {
  const { t } = useTranslation()

  const { values, setFieldValue, setValues } = formik

  const countryOfOperation = values[COUNTRY_ID]
  const previousCountry = useRef(countryOfOperation)

  const changeCountryHandler = useCallback(
    country => {
      if (previousCountry.current && previousCountry.current !== country) {
        const updatedStakeholdersList = values[STAKEHOLDERS_LIST].map(item => {
          const { [ETHNICITY_PERCENTAGE]: ethnicityFieldsValues } = item
          const updatedEthnicityFieldsValues = {}

          Object.keys(ethnicityFieldsValues).forEach(key => {
            updatedEthnicityFieldsValues[key] = 0
          })

          return {
            ...item,
            [ETHNICITY_PERCENTAGE]: updatedEthnicityFieldsValues
          }
        })

        setValues({
          ...values,
          [STAKEHOLDERS_LIST]: updatedStakeholdersList
        })
      }
      previousCountry.current = country

      setFieldValue(COUNTRY_ID, country)
    },
    [setFieldValue, setValues, values]
  )

  return (
    <Field
      placeholder={t('Select Country')}
      formik={formik}
      name={COUNTRY_ID}
      options={operationsCountriesOptions}
      onValueChange={changeCountryHandler}
    />
  )
}

export default CountryOfOperationField
